import {e2p, isMobileOrTablet} from "../bootstrap/components/extensions";

function initOwlCarousel() {
    jQuery(".owl-carousel").each(function () {
        const $owl = jQuery(this);
        const perPage = $owl.attr('data-perpage') || 5;

        console.log('Mobile or tablet', isMobileOrTablet()? 1.5 : perPage);

        const owl = $owl.owlCarousel({
            nav             : true,
            slideSpeed      : 300,
            paginationSpeed : 400,
            items           : isMobileOrTablet()? 1.5 : perPage,
            margin          : 32,
            rtl             : true,
            autoplay        : false,
            stopOnHover     : true,
            loop            : true,
            animateOut      : 'fadeOut',
            mouseDrag       : true,
            touchDrag       : true,
            autoplayHoverPause:true
        });

        owl.on('changed.owl.carousel', function(event) {
        })
    })
}
initOwlCarousel()

function initCountDown() {
    const $timer = jQuery(".timer");

    if($timer.length) {
        $timer.each(function () {
            const $this = jQuery(this);
            const blackFridayDate = $this.attr('data-timestamp');

            if (blackFridayDate) {
                const $hours = $this.find('.hours');
                const $minutes = $this.find('.minutes');
                const $seconds = $this.find('.seconds');

                const interval = setInterval(function () {

                    const now = new Date().getTime();

                    // Calculate remaining time
                    const timeRemaining = blackFridayDate - now;

                    if (timeRemaining >= 0)
                    {
                        // Time calculations for days, hours, minutes, and seconds
                        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                        $hours.html(e2p(String(hours).padStart(2, '0')));
                        $minutes.html(e2p(String(minutes).padStart(2, '0')));
                        $seconds.html(e2p(String(seconds).padStart(2, '0')));
                    }
                    else
                    {
                        clearInterval(interval);
                    }

                }, 1000);
            }
        });
    }
}
initCountDown();